import React from 'react'

import Button from '../../Button/Button'
import EmptyState from '../../EmptyState/EmptyState'

const AddRemoveDescription = ({ onOpenAddColumn }) => {
  const handleAddRemoveClick = () => {
    onOpenAddColumn(true)
  }

  return (
    <>
      <div>
        Looks like there isn't any data available for the selected columns. Try selecting different column filters
      </div>
      <Button className="mt-10" onClick={handleAddRemoveClick}>
        Add columns
      </Button>
    </>
  )
}

const ComposeEmptyState = (props) => {
  const { isNewEmptyState, noVisibleColumn, onOpenAddColumn, emptyObj, emptyHead, emptyDesc, customEmptyState } = props

  const emptyStateNodes = noVisibleColumn ? (
    <EmptyState
      heading="No visible columns"
      description={<AddRemoveDescription onOpenAddColumn={onOpenAddColumn} />}
      type="primary"
    />
  ) : (
    !customEmptyState ?
      <EmptyState
        heading={(emptyObj && emptyObj.heading) || emptyHead}
        description={(emptyObj && emptyObj.description) || emptyDesc}
        displayImage={false}
        type="primary"
        actions={emptyObj && emptyObj.actions}
        moduleIcon={emptyObj && emptyObj.moduleIcon}
        forPage={emptyObj && emptyObj.forPage}
        newEmptyState={emptyObj && emptyObj.newEmptyState}
      /> : customEmptyState
  )

  if (isNewEmptyState) {
    return (
      <div className="Table__centerWrapper" data-test-id="cs-table-center-wrapper">
        {emptyStateNodes}
      </div>
    )
  }

  return <>{emptyStateNodes}</>
}


export default ComposeEmptyState
